import { render, staticRenderFns } from "./enterAmount.vue?vue&type=template&id=a97495ac&scoped=true"
import script from "./enterAmount.vue?vue&type=script&lang=js"
export * from "./enterAmount.vue?vue&type=script&lang=js"
import style0 from "./enterAmount.vue?vue&type=style&index=0&id=a97495ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97495ac",
  null
  
)

export default component.exports